var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("Table Option")]),(_vm.editor)?_c('div',[_c('button',{on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .insertTable({ rows: 3, cols: 3, withHeaderRow: true })
          .run()}}},[_vm._v(" insertTable ")]),_c('button',{on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .addColumnBefore()
          .run()}}},[_vm._v(" addColumnBefore ")]),_c('button',{on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .addColumnAfter()
          .run()}}},[_vm._v(" addColumnAfter ")]),_c('button',{on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .deleteColumn()
          .run()}}},[_vm._v(" deleteColumn ")]),_c('button',{on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .addRowBefore()
          .run()}}},[_vm._v(" addRowBefore ")]),_c('button',{on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .addRowAfter()
          .run()}}},[_vm._v(" addRowAfter ")]),_c('button',{on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .deleteRow()
          .run()}}},[_vm._v(" deleteRow ")]),_c('button',{on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .deleteTable()
          .run()}}},[_vm._v(" deleteTable ")]),_c('button',{on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .mergeCells()
          .run()}}},[_vm._v(" mergeCells ")]),_c('button',{on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .splitCell()
          .run()}}},[_vm._v(" splitCell ")]),_c('button',{on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .toggleHeaderColumn()
          .run()}}},[_vm._v(" toggleHeaderColumn ")]),_c('button',{on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .toggleHeaderRow()
          .run()}}},[_vm._v(" toggleHeaderRow ")]),_c('button',{on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .toggleHeaderCell()
          .run()}}},[_vm._v(" toggleHeaderCell ")]),_c('button',{on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .mergeOrSplit()
          .run()}}},[_vm._v(" mergeOrSplit ")]),_c('button',{on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .setCellAttribute('colspan', 2)
          .run()}}},[_vm._v(" setCellAttribute ")]),_c('button',{on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .fixTables()
          .run()}}},[_vm._v(" fixTables ")]),_c('button',{on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .goToNextCell()
          .run()}}},[_vm._v(" goToNextCell ")]),_c('button',{on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .goToPreviousCell()
          .run()}}},[_vm._v(" goToPreviousCell ")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }